import React from 'react';
import Meta from 'src/components/Meta';
import { useGaEventPageView } from 'src/utils/gaEvent';
import { PageContainer, Spacer, TitleWithBack } from 'src/common';
import { ScenarioLibraryTableSection } from './comps';
import { TableIds } from 'src/api/types/misc';
import { useScenarioTemplatesQuery } from 'src/graphql/_generated';
import { isQueryLoading } from 'src/graphql/client';

const ScenarioLibraryAllPage = () => {
  useGaEventPageView('Cydea | Scenario Library | All');

  const { data: { scenarioTemplates } = {}, loading, networkStatus } = useScenarioTemplatesQuery();
  const isLoading = isQueryLoading({ loading, data: scenarioTemplates, networkStatus });

  return (
    <>
      <Meta title={`Cydea | Scenario Library | All`} feedbackScript />
      <PageContainer>
        <TitleWithBack title="All Scenarios" />
        <Spacer $px={20} />
        <ScenarioLibraryTableSection
          data={scenarioTemplates}
          isLoading={isLoading}
          tableId={TableIds.scenarioLib}
          title="Scenario Library"
        />
      </PageContainer>
    </>
  );
};

export default ScenarioLibraryAllPage;
